import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class PermissionEffects {
  constructor(
    private actions$: Actions
  ) { }
}
